import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';


@Component({
  selector: 'app-send-mail-modal',
  standalone: true,
  imports: [MatDialogModule],
  templateUrl: './send-mail-modal.component.html',
  styleUrl: './send-mail-modal.component.css'
})
export class SendMailModalComponent {
  constructor(
    public dialogRef: MatDialogRef<SendMailModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { censoredMail: string }
  ) {}
}
